import { Star, Quote } from "lucide-react";
import { Reveal } from "./Reveal";

const DEPOIMENTOS = [
    {
        nome: "Carlos M.",
        negocio: "Pizzaria no Campo Limpo",
        texto: "O cardápio digital mudou meu delivery. Os pedidos chegam prontos no WhatsApp e eu parei de pagar comissão para aplicativo. No primeiro mês já vi a diferença no caixa.",
    },
    {
        nome: "Fernanda R.",
        negocio: "Doceria na Zona Sul",
        texto: "Meu site ficou pronto rápido e os clientes já me encontram no Google. O atendimento foi direto, sem enrolação, e qualquer ajuste é resolvido no mesmo dia.",
    },
    {
        nome: "Paulo S.",
        negocio: "Escritório no Capão Redondo",
        texto: "Formatou e otimizou todos os computadores do escritório. Atendimento presencial rápido e preço justo — coisa de quem é do bairro e entende a nossa realidade.",
    },
];

export const Testimonials = () => (
    <section id="depoimentos" data-testid="testimonials-section" className="relative py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <Reveal className="max-w-2xl">
                <span className="text-xs font-bold uppercase tracking-[0.24em] text-cyan-400">
                    Depoimentos
                </span>
                <h2 className="mt-4 text-3xl font-bold tracking-tight text-slate-50 sm:text-4xl">
                    Quem é do bairro confia na Strondex Tech
                </h2>
                <p className="mt-4 text-base text-slate-400 sm:text-lg">
                    Comércios e profissionais da região que já transformaram a rotina
                    com nossas soluções.
                </p>
            </Reveal>

            <div className="mt-14 grid gap-6 md:grid-cols-3">
                {DEPOIMENTOS.map((d, i) => (
                    <Reveal key={d.nome} delay={i * 0.12}>
                        <figure
                            data-testid={`testimonial-card-${i}`}
                            className="flex h-full flex-col rounded-2xl border border-white/[0.07] bg-[#111827] p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-cyan-400/40 hover:shadow-[0_12px_36px_rgba(0,136,255,0.12)]"
                        >
                            <div className="flex items-center justify-between">
                                <div className="flex gap-1" aria-label="5 estrelas">
                                    {Array.from({ length: 5 }).map((_, s) => (
                                        <Star key={s} size={15} className="fill-[#25D366] text-[#25D366]" />
                                    ))}
                                </div>
                                <Quote size={22} className="text-cyan-400/30" aria-hidden="true" />
                            </div>
                            <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-slate-300">
                                “{d.texto}”
                            </blockquote>
                            <figcaption className="mt-6 border-t border-white/[0.06] pt-4">
                                <p className="text-sm font-bold text-slate-100">{d.nome}</p>
                                <p className="mt-0.5 text-xs text-slate-500">{d.negocio}</p>
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
